<template>
  <div class="container-content">
    <div class="bubble">
      <div class="bubble-title">{{ $t('common.congratulations') }}</div>
      <div class="bubble-text" v-html="$t('self.employed.status.confirmed.successfully')"></div>
      <div class="bubble-button">
        <button @click.prevent="handleSubmit">
          {{ $t('common.proceed') }}
        </button>
      </div>
    </div>
    <div v-if="isBetaTest" class="change-theme">
      <div class="change-theme-button">
        <button @click="handleChangeTheme">
          <div class="change-theme-icon"></div>
        </button>
      </div>
      <div class="change-theme-text">
        {{ $t('try.light.interface.theme') }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import { isBetaTest } from 'lib/system/env';

export default {
  name: 'ApprovalSelfEmployed',
  data() {
    return {
      isBetaTest: isBetaTest(),
    };
  },
  methods: {
    handleSubmit() {
      this.GET_SELF_EMPLOYED_STATUS();
      this.FETCH_SELF_EMPLOYED_NOTIFICATIONS();
    },
    handleChangeTheme() {
      this.CHANGE_THEME();
    },
    ...mapActions(['CHANGE_THEME', 'GET_SELF_EMPLOYED_STATUS', 'FETCH_SELF_EMPLOYED_NOTIFICATIONS']),
  },
};
</script>

<style lang="sass" scoped>
  .container-content
    width: 100%
    padding: 20px 0 60px
    position: relative
    top: 220px

    +respond-to("small")
      width: 500px
      margin: 0 auto
      padding: 150px 0
      top: 0

  .bubble
    position: relative
    margin-bottom: 30px
    padding: 20px
    background: rgba(24, 24, 35, 0.75)

    +respond-to("small")
      margin-bottom: 40px
      border-radius: 10px

  .bubble-title
    margin-bottom: 20px
    font-size: 20px
    line-height: 40px
    color: #fff

  .bubble-text
    margin-bottom: 20px
    font-weight: 500
    font-size: 14px
    line-height: 20px
    color: #fff
    opacity: 0.75

    a
      color: #7CB342
      text-decoration: underline

      &:hover
        text-decoration: none

    &::deep span
      display: inline-block

    +respond-to("small")
      margin-bottom: 40px
      padding-right: 100px

      &::deep span
        display: inline

  .bubble-button
    button
      width: 100%
      display: block
      padding: 16px
      font-weight: 600
      font-size: 18px
      line-height: 18px
      border-radius: 2rem
      background-color: #7CB342
      box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.25)

      +respond-to("small")
        width: 300px

      &:hover
        box-shadow: inset 0 -0.24rem 0 rgba(0, 0, 0, 0.2), 0 0.24rem 0.24rem rgba(124, 179, 66, 0.2)

  .change-theme
    display: flex
    flex-direction: column

    +respond-to("small")
      flex-direction: row

  .change-theme-icon
    width: 22px
    height: 22px
    margin: 0 auto
    background-image: url("~@/assets/img/icons/theme-change.svg")
    background-repeat: no-repeat

  .change-theme-text
    text-align: center
    font-weight: 500
    font-size: 14px
    line-height: 20px
    color: #fff
    opacity: .75

    +respond-to("small")
      text-align: left

  .change-theme-button
    margin-bottom: 20px
    padding: 0 20px

    button
      width: 100%
      height: 40px
      display: block
      margin: 0 auto
      padding: 10px
      background: #fff
      box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15)
      border-radius: 50px

      +respond-to("small")
        width: 140px

</style>
